import { API_URL } from '../config/config';
import { getRequest } from '../utils/axiosUtils';
import buildQueryParams from '../utils/buildQueryParams';


export const fetchNyDashboardStatsData = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/nyDashboard?${queryParams}`,
  });
  if(!res) return

  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchRevenueNyPlanWise = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getRevenuePlanWise?${queryParams}`,
  });
  if(!res) return

  if (res.status >= 200 && res.status < 300 && res.data) {
    return { data: res.data.data, marketingStats: res.data.marketingStats, organicStats: res.data.organicStats };
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchActivityMatrixNy = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getActivityMatrix?${queryParams}`,
  });
  if(!res) return

  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchSignUpDistribution = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getSignUpDistributionByDevice?${queryParams}`,
  });
  
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    console.log("res---------",res.data.data);
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchDailySignUpTrend = async (filter) => {
  const { country, state, city, date, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getDailySignUpTrend?${queryParams}&date=${date}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchWeeklySignUpTrend = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload, week, year } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getWeeklySignUpTrend?${queryParams}&week=${week}&year=${year}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchMonthlySignUpTrend = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload, month, year } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getMonthlySignUpTrend?${queryParams}&month=${month}&year=${year}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
export const fetchConversionFunnel = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getConversionFunnel?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchCommunicationActivity = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getCommunicationActivity?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchFinancialMetrics = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getFinancialMetrics?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchNYUserFunnel = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getNYUserFunnel?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchNYUserActivityFunnel = async (filter) => {
  const { country, state, city, dateRange, gender, utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getNYUserActivityFunnel?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    return res.data.data;
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};